export default {
  AnswerBrief: 'خلاصه پاسخ',
  AnswerFull: 'پاسخ کامل',
  ClientType: 'مخاطبین',
  Question: 'پرسش',
  Category: 'دسته بندی',
  question_: 'سوال',
  dependentQuestion: 'سوال وابسته',
  dependencyCriteria: 'معیار سوال وابسته',
  domain: 'دامنه',
  subDomain: 'زیر دامنه',
  header: 'Header',
  footer: 'Footer',
  sidebar: 'Sidebar',
  topHeader: 'Top-Header',
  type: 'نوع',
  selectFromTemplate: 'انتخاب از الگوها',
  faqCategoryId: 'شناسه دسته سوالات متداول',
  postCategoryId: 'شناسه دسته پست',
  answerBrief: 'خلاصه پاسخ',
  answerFull: 'پاسخ کامل',
  clientType: 'مخاطبین',
  question: 'پرسش',
  primaryCategory: 'دسته بندی اصلی',
  categories: 'دسته بندی ها',
  response: 'پاسخ',
  responder: 'پاسخ دهنده',
  commentResponseSuccessfullyRegisterd: 'پاسخ دیدگاه با موفقیت ثبت شد',
  approve: 'تائید',
  reject: 'رد',
  commentResponse: 'پاسخ دیدگاه',
  tags: 'تگ ها',
  excerpt: 'خلاصه',
  tutorial: 'راهنمای استفاده'
}
